import styled from 'styled-components';
import { SectionTitle as RawSectionTitle } from '../../SectionTitle';

import {
  colors,
  typography,
  size,
  mediaQueries,
  Col as RawCol,
} from '@everlywell/leaves';

export const SectionTitle = styled(RawSectionTitle)`
  text-align: center;
  margin-bottom: ${size.xs1}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.sm}px;
  }
`;

const SectionHeadline = styled.h2`
  ${typography.h3Text}
  color: ${colors.teal4};
  text-align: center;
  font-weight: ${typography.weight.regular};
  margin-bottom: ${size.xl1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.h2Text}
    color: ${colors.teal4};
    margin-bottom: ${size.xl4}px;
  }
`;

const SectionSubheadline = styled.p`
  ${typography.bodyText}
  color: ${colors.gray4};
  margin-bottom: ${size.xl1}px;
  text-align: left;
  ${mediaQueries.forTabletHorizontalUp} {
    text-align: center;
    margin-bottom: ${size.xl4}px;
  }
`;

const StatsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  ${mediaQueries.forTabletHorizontalUp} {
    display: grid;
    flex-direction: unset;
    align-items: unset;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: 1fr;
    grid-column-gap: 24px;
  }
`;

const Description = styled.div`
  ${typography.bodyText};
  font-size: 11px;
  padding: 0 ${size.xl1}px;
  line-height: 24px;
  margin-top: ${size.xs1}px;
`;

export { SectionHeadline, SectionSubheadline, StatsCardContainer, Description };
